import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=b9e36bda&scoped=true"
import script from "./ProductsFilter.vue?vue&type=script&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e36bda",
  null
  
)

export default component.exports